<div class="full-page-loader">
  <div class="center-align-data" [class.mascot-variant]="icon === 'mascot'">
    <img *ngIf="icon === 'mascot'" class="mascot" [src]="mascotImg" alt="" fetchpriority="high"
      decoding="sync" />
    <div *ngIf="icon === 'logo'" class="logo" cygovSvgIcon
      svgName="centraleyes-logo1-animated"></div>
    <div class="progress-bar-details">
      <cygov-progress-bar class="progress-bar" [assessmentLevel]="progress"
        [postFill]="['var(--color-btn-primary)', 'var(--color-btn-primary)']"
        [preFill]="'var(--color-progress-bar-bg)'" [height]="15">
      </cygov-progress-bar>
    </div>
    <span class="lato-20-n-vw" *ngIf="caption">{{ caption }}</span>
  </div>
</div>
